// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Services
import Person from 'services/data/person';

// Actions
import * as actions from './store/actions';

// Components
import { Page, PageHeader, PageContent, Tabs, Tab } from 'components/page';
import SVG from 'components/widgets/icons/svg';

// Component
class ViewPerson extends React.Component {
  static propTypes = {
    personId: PropTypes.string,
    currentUser: PropTypes.object,
    person: PropTypes.object,
    children: PropTypes.node,
    fetching: PropTypes.bool,
    location: PropTypes.object
  };

  static defaultProps = {
    person: {}
  };

  constructor(props) {
    super(props);

    this.loadPerson = this.loadPerson.bind(this);
    this.updatePerson = this.updatePerson.bind(this);
  }

  componentDidMount() {
    this.loadPerson();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.personId !== this.props.personId) this.loadPerson(nextProps.personId);
  }

  loadPerson(id) {
    actions.set({ fetching: true });
    const load = ['emailAddresses.billingCompanies', 'phoneNumbers', 'addresses', 'company', 'team'];

    return Person.findOne(id || this.props.personId, { load })
      .then(person => {
        actions.set({ fetching: false, person });
      });
  }

  updatePerson(updates) {
    const { person } = this.props;
    actions.set({ person: _.assign({}, person, updates) });

    return Person.update(_.assign({ id: person.id }, updates));
  }

  render() {
    const { person, personId, fetching, location, children } = this.props;
    const parts = _.compact(_.split(location.pathname, '/'));
    const url = _.join(_.take(parts, parts.length - 2), '/');

    const clonedChildren = React.cloneElement(children, {
      load: this.loadPerson,
      update: this.updatePerson
    });

    if (!person || _.isEmpty(person)) return null;

    return (
      <Page className="person-page">
        <PageHeader title={Person.fullName(person)}>
          <Tabs className="actions-tabs">
            <Tab to={`/${url}/${personId}/summary`}>
              <SVG src="svg/person.svg" className="person" />
              <span>Summary</span>
            </Tab>
          </Tabs>
        </PageHeader>
        <PageContent fetching={fetching} className="person bg-medium-blue-grey">
          {clonedChildren}
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state, ownProps) => ({
  fetching: state.people.fetching,
  person: state.people.person,
  personId: ownProps.routeParams.personId,
  currentUser: state.auth.currentUser,
  location: state.location
}))(ViewPerson);
